var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 41,
    viewBox: "0 0 50 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3704 6.30769H37.5L35.625 1.19396C35.4955 0.844037 35.2581 0.541571 34.9453 0.327874C34.6325 0.114177 34.2595 -0.000328123 33.8773 7.06252e-07H16.1227C15.3414 7.06252e-07 14.6412 0.478709 14.3808 1.19396L12.5 6.30769H4.62963C2.07176 6.30769 0 8.3239 0 10.8132V36.4945C0 38.9838 2.07176 41 4.62963 41H45.3704C47.9282 41 50 38.9838 50 36.4945V10.8132C50 8.3239 47.9282 6.30769 45.3704 6.30769ZM45.8333 36.4945C45.8333 36.7423 45.625 36.9451 45.3704 36.9451H4.62963C4.375 36.9451 4.16667 36.7423 4.16667 36.4945V10.8132C4.16667 10.5654 4.375 10.3626 4.62963 10.3626H15.434L16.4236 7.67061L17.7488 4.05495H32.2454L33.5706 7.67061L34.5602 10.3626H45.3704C45.625 10.3626 45.8333 10.5654 45.8333 10.8132V36.4945ZM25 13.967C19.8843 13.967 15.7407 17.9995 15.7407 22.978C15.7407 27.9566 19.8843 31.989 25 31.989C30.1157 31.989 34.2593 27.9566 34.2593 22.978C34.2593 17.9995 30.1157 13.967 25 13.967ZM25 28.3846C21.9329 28.3846 19.4444 25.9629 19.4444 22.978C19.4444 19.9931 21.9329 17.5714 25 17.5714C28.0671 17.5714 30.5556 19.9931 30.5556 22.978C30.5556 25.9629 28.0671 28.3846 25 28.3846Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.d92ba61a1d3572a6cf605d60046d0b93.svg";
export { ForwardRef as ReactComponent };